<template>
    <div class="campaign-donations">
        <h3 class="section-title mb-4">{{ title }}</h3>

        <v-card v-if="!hasDonations" elevation="0" outlined class="pa-6 text-center empty-card">
            <v-icon size="48" color="grey lighten-1">mdi-heart-outline</v-icon>
            <p class="mt-3 grey--text">{{ emptyMessage }}</p>
        </v-card>

        <v-card v-else elevation="0" outlined class="donations-card pa-4">
            <template v-for="(donation, index) in donations">
                <v-divider v-if="index > 0" :key="'divider-' + index" class="my-3"></v-divider>
                <div :key="donation.id || index" class="donation-item">
                    <v-row align="center">
                        <v-col cols="auto">
                            <v-icon color="primary" size="32">mdi-heart</v-icon>
                        </v-col>
                        <v-col>
                            <div class="donation-info">
                                <span class="donor-name">
                                    {{ donation.is_anonymous ? 'Anonymous' : donation.donor_name }}
                                </span>
                                {{ isOwner ? 'sent you' : 'donated' }}
                                <span class="donation-amount">${{ formatMoney(donation.amount) }}</span>
                            </div>
                            <div class="donation-date">{{ formatDate(donation.created_at) }}</div>
                        </v-col>
                    </v-row>
                    <v-card
                        v-if="donation.donor_note"
                        elevation="0"
                        color="#f4f5f6"
                        class="pa-3 mt-3 donation-note"
                    >
                        "{{ donation.donor_note }}"
                    </v-card>
                </div>
            </template>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'CampaignDonations',
    props: {
        donations: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: 'Recent Donations'
        },
        emptyMessage: {
            type: String,
            default: 'No donations yet. Be the first to contribute!'
        },
        isOwner: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasDonations() {
            return this.donations?.length > 0
        }
    },
    methods: {
        formatMoney(amount) {
            return (Number(amount) / 100).toFixed(2)
        },
        formatDate(date) {
            return moment(date).format('LL')
        }
    }
}
</script>

<style scoped>
.section-title {
    font-size: 20px;
    font-weight: 700;
    color: #333;
}

.empty-card {
    border-radius: 10px !important;
}

.donations-card {
    border-radius: 10px !important;
}

.donation-item {
    padding: 8px 0;
}

.donation-info {
    font-size: 15px;
    color: #333;
}

.donor-name,
.donation-amount {
    font-weight: 600;
}

.donation-date {
    font-size: 12px;
    color: #999;
    font-style: italic;
    margin-top: 2px;
}

.donation-note {
    font-size: 14px;
    font-style: italic;
    color: #555;
    border-radius: 8px !important;
}
</style>
